export default function Vision() {
  return (
    <section
      data-testid="vision-section"
      className="relative py-32 md:py-44 overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-40"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1633259584604-afdc243122ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGRhcmslMjBibHVlJTIwY3lhbiUyMGdsb3dpbmclMjB3YXZlc3xlbnwwfHx8fDE3ODMyMzUyODN8MA&ixlib=rb-4.1.0&q=85)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#05050A] via-[#05050A]/60 to-[#05050A]" />
      <div className="absolute inset-0 grid-lines opacity-20" />

      <div className="relative max-w-6xl mx-auto px-6 text-center">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-cyan-400">
          Vision / 05
        </p>
        <h2 className="font-display mt-6 text-4xl sm:text-6xl lg:text-7xl font-semibold tracking-tighter leading-[1.02]">
          The Future of{" "}
          <span className="text-gradient-cyan">Preventive Healthcare.</span>
        </h2>
        <p className="mt-8 max-w-3xl mx-auto text-lg md:text-xl text-zinc-400 leading-relaxed">
          Our vision is to make preventive health awareness accessible to
          everyone. SilentScan AI empowers people with meaningful health
          insights so they can make informed lifestyle decisions before health
          issues become serious.
        </p>
      </div>
    </section>
  );
}
